import React from 'react';
import SVGIcon from '../../../assets/images/svg/SVGIcon';
import {
  Group,
  Container,
  TableHeader,
  TitleWrap,
  TitleWrapper,
  TitleWrappers,
  TableData,
  UserDetails,
  UserName,
  UserDescription,
  UserMail,
  UserNumber,
  PrivateData
} from './styles';
import { ICON_SIZE } from '../../../global/constants';

const LoadingState: React.FC = () => {
  return (
    <Group>
      <Container>
        <TableHeader>
          <TitleWrap>Name</TitleWrap>
          <TitleWrapper>EMAIL</TitleWrapper>
          <TitleWrappers>PHONE</TitleWrappers>
        </TableHeader>
        <TableData>
          <UserDetails>
            <UserName className='loading-animation' />
            <UserDescription className='loading-animation' />
          </UserDetails>
          <PrivateData>
            <UserMail className='loading-animation' />
            <UserNumber className='loading-animation' />
          </PrivateData>
          <SVGIcon
            name='three-dots-horizontal-icon'
            width={ICON_SIZE.LG}
            height={ICON_SIZE.LG}
            viewBox={`0 0 ${ICON_SIZE.LG} ${ICON_SIZE.LG}`}
            fill='var(--background-muted)'
          />
        </TableData>
        <TableData>
          <UserDetails>
            <UserName className='loading-animation' />
            <UserDescription className='loading-animation' />
          </UserDetails>
          <PrivateData>
            <UserMail className='loading-animation' />
            <UserNumber className='loading-animation' />
          </PrivateData>
          <SVGIcon
            name='three-dots-horizontal-icon'
            width={ICON_SIZE.LG}
            height={ICON_SIZE.LG}
            viewBox={`0 0 ${ICON_SIZE.LG} ${ICON_SIZE.LG}`}
            fill='var(--background-muted)'
          />
        </TableData>
        <TableData>
          <UserDetails>
            <UserName className='loading-animation' />
            <UserDescription className='loading-animation' />
          </UserDetails>
          <PrivateData>
            <UserMail className='loading-animation' />
            <UserNumber className='loading-animation' />
          </PrivateData>
          <SVGIcon
            name='three-dots-horizontal-icon'
            width={ICON_SIZE.LG}
            height={ICON_SIZE.LG}
            viewBox={`0 0 ${ICON_SIZE.LG} ${ICON_SIZE.LG}`}
            fill='var(--background-muted)'
          />
        </TableData>
        <TableData>
          <UserDetails>
            <UserName className='loading-animation' />
            <UserDescription className='loading-animation' />
          </UserDetails>
          <PrivateData>
            <UserMail className='loading-animation' />
            <UserNumber className='loading-animation' />
          </PrivateData>
          <SVGIcon
            name='three-dots-horizontal-icon'
            width={ICON_SIZE.LG}
            height={ICON_SIZE.LG}
            viewBox={`0 0 ${ICON_SIZE.LG} ${ICON_SIZE.LG}`}
            fill='var(--background-muted)'
          />
        </TableData>
        <TableData>
          <UserDetails>
            <UserName className='loading-animation' />
            <UserDescription className='loading-animation' />
          </UserDetails>
          <PrivateData>
            <UserMail className='loading-animation' />
            <UserNumber className='loading-animation' />
          </PrivateData>
          <SVGIcon
            name='three-dots-horizontal-icon'
            width={ICON_SIZE.LG}
            height={ICON_SIZE.LG}
            viewBox={`0 0 ${ICON_SIZE.LG} ${ICON_SIZE.LG}`}
            fill='var(--background-muted)'
          />
        </TableData>
      </Container>
    </Group>
  );
};

export default LoadingState;
